(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('HaqTracksService', HaqTracksService);

    HaqTracksService.$inject = ['$resource','$q', 'halClient', '$http', 'DateUtils'];

    function HaqTracksService($resource, $q, halClient, $http, DateUtils) {
        var baseUrl = 'api/haq-tracks';
        var resourceUrl = "api/haq-tracks/:id";
        var service = $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'delete': {method: 'DELETE'}
        });
        service.getAllBatteryDefault = getAllBatteryDefault;
        service.findAll = findAll;
        service.findById = findById;

        function getAllBatteryDefault() {
            var deferred = $q.defer();
            var url = baseUrl + '/get-all-battery-default';
            $http.get(url)
                .success(function (result) {
                    deferred.resolve(result);
                }).error(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function findAll(pageable) {
            var deferred = $q.defer();

            var url = baseUrl + '/find-all';
            $http.get(url, {
                params: {
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).success(function (data, status, headers) {
                var result = new Object();
                result.data = data && data !== undefined ? data : [];
                result.totalItems = headers('X-Total-Count');
                deferred.resolve(result);
            }).error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        function findById(id) {
            var deferred = $q.defer();
            var url = baseUrl + "/" + id;
            halClient.$get(url).then(function success(result) {
                deferred.resolve(result);
            }, function error(e) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        return service;

    }
})();
